import * as React from 'react'
import { ReactElement } from 'react'
import { tokens } from '@fluentui/react-theme'
import { makeStyles } from '@fluentui/react-components'
import AlertDialog from '../Dialog/AlertDialog'
import { bundleIcon, PlugDisconnectedFilled, PlugDisconnectedRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

type Props = {
    disabled?: boolean
    className?: string
    buttonClassName?: string
    // Property to prevent the click event inside the dialog to reach elements outside the dialog which in turn cause the dialog to close.
    setPreventDefaultEvent?: (value: boolean) => void
    onConfirm?: (setOpen: (open: boolean) => void, setSubmitting: (submitting: boolean) => void) => void
}

const DisconnectIcon = bundleIcon(PlugDisconnectedFilled, PlugDisconnectedRegular)

const useStyles = makeStyles({
    deleteButton: {
        backgroundColor: tokens.colorPaletteRedForeground3,
        '&:hover, &:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground1} !important`,
        },
        '&:hover:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground2} !important`,
        },
    },
})

export default function DisconnectInvoiceButton(props: Props): ReactElement {
    const { t: translate } = useTranslation()
    const styles = useStyles()

    return (
        <AlertDialog
            className={props.className}
            onConfirm={props.onConfirm}
            title={translate('invoice.edit.action.unlock.title')}
            content={translate('invoice.edit.action.unlock.subtitle')}
            triggerButtonProps={{
                className: props.buttonClassName,
                disabled: props.disabled,
                appearance: 'transparent',
                icon: <DisconnectIcon />,
                children: translate('action.unlock'),
            }}
            confirmButtonProps={{
                icon: <DisconnectIcon />,
                className: styles.deleteButton,
            }}
        />
    )
}
